import { FormsModule } from '@angular/forms';
import { LabelComponent } from './label.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [
    LabelComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    LabelComponent
  ]
})
export class LabelModule { }
